import React from 'react';
import { Link, useLocation } from 'react-router-dom';

// Mobile bottom tab bar — the phone-first primary nav. Labels only: the words
// name the destinations clearly on their own, so dropping the icons buys back a
// chunk of the bar's height and lets the text breathe. Desktop uses the sidebar
// instead; this is hidden at md+.

const Tab = ({ to, label, active }) => (
  <Link
    to={to}
    className={`flex items-center justify-center h-full min-w-0 text-base font-semibold transition-colors ${
      active
        ? 'text-primary-600 dark:text-primary-400'
        : 'text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200'
    }`}
  >
    <span className="leading-none">{label}</span>
  </Link>
);

const BottomNav = () => {
  const { pathname } = useLocation();
  const is = (p) => pathname === p;

  return (
    <nav
      className="md:hidden fixed bottom-0 inset-x-0 z-50 h-[60px] px-1
                 grid grid-cols-5 items-stretch
                 bg-surface-card/95 dark:bg-black/95 backdrop-blur
                 border-t border-surface-border dark:border-surface-dark-border"
      style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}
      aria-label="Primary"
    >
      <Tab to="/you" label="You" active={is('/you')} />
      <Tab to="/log" label="Log" active={is('/log')} />
      <Tab to="/data" label="Data" active={is('/data')} />
      <Tab to="/insights" label="Insights" active={is('/insights')} />
      <Tab to="/supplements" label="Supps" active={is('/supplements')} />
    </nav>
  );
};

export default BottomNav;
